import {IAuthService} from "external-services/diary-admin-service/types";
import AdminService from "external-services/diary-admin-service/admin.service";
import LoginActions from "app/actions/login.actions";

const NS = 'GCManagementLoaderCtrl';

const GC_PAGE_URL = `${window.location.origin}/gift-cards.html#!/gift-cards-management`;

export default function GCManagementLoaderCtrl(
  $scope: any, unregister: any, AuthService: IAuthService, $element: any
) {
  "ngInject";

  const vm = this;
  vm.showNotActiveMessage = false;
  vm.showLoader = false;

  const giftCardsIFrame: HTMLIFrameElement = $element.find('#giftCardsIFrame')[0];

  const updateTokenHandler = (event: {data: any}) => {
    console.log('event', event)

    if (event.data === 'updateToken') {
      const token = AuthService.getBearerToken();
      giftCardsIFrame.contentWindow.postMessage({type: 'updateToken', token}, window.location.origin);
      vm.showLoader = false;
    }
  };

  vm.openInNewTab = () => {
    setTimeout(() => {

      const token = AuthService.getBearerToken();
      const venue = AdminService.getVenue();
      const venueId = venue.id;
      const accountId = venue.accountId;

      const bc = new BroadcastChannel("giftCardsAuth");
      bc.postMessage({type: 'auth', token, venueId, accountId});

      // @todo implement 'updateToken' postmessage using BroadcastChannel as well
    }, 5000)
  }

  const listeners: any[] = [];
  listeners.push($scope.$on('$destroy', () => {
    giftCardsIFrame.contentWindow.removeEventListener("message", updateTokenHandler);
    unregister(listeners);
  }));

  giftCardsIFrame.onload = () => {
    LoginActions.registerForReadyCB(() => {

      const token = AuthService.getBearerToken();
      const venue = AdminService.getVenue();
      const venueId = venue.id;
      const accountId = venue.accountId;

      if (venue.isGiftCardActive) {
        giftCardsIFrame.contentWindow.postMessage({type: 'auth', token, venueId, accountId}, window.location.origin);
        giftCardsIFrame.contentWindow.addEventListener("message", updateTokenHandler);
      } else {
        vm.showNotActiveMessage = true;
      }

    });
  }

  giftCardsIFrame.src = GC_PAGE_URL;
  vm.showLoader = true;

}
